import { type AppDispatch, type RootState } from "features/Application/globaltypes/redux";
import { bindAction } from "interfaces/redux";
import { campaignsStateSelector } from "../../state/selectors";
import { connect } from "react-redux";
import GenericItemsView, { type GenericItemsViewProps } from "views/ItemsView/GenericItemsView";
import { type CampaignOverview } from "../../types/state";
import { getOverviewFilterOptions } from "../../state/thunks/campaignFiltersThunk";
import { type FiltersMap } from "utils/filterUtils";
import { resetAppliedFilter, setAppliedFilter } from "../../state/slices/campaignFiltersSlice";

/* istanbul ignore next */
const mapStateToProps = (state: RootState) => {
  const campaignsState = campaignsStateSelector(state);
  const overview = campaignsState.overview;
  const entityState = campaignsState.base.entityState;

  return {
    items: overview.campaigns.items,
    isLoading: overview.campaigns.isLoading || entityState.changingEntityState,
    dataCount: overview.campaigns.itemsCount,
    filterOptionsLoading: overview.filters.isLoading,
    filterOptions: overview.filters.filterOptions,
    appliedFilter: overview.filters.appliedFilter,
    isAllDataLoaded: overview.campaigns.areAllLoaded,
    className: "alignment-padding",
  };
};

/* istanbul ignore next */
const mapDispatchToProps = (dispatch: AppDispatch) => ({
  getFilterOptions: bindAction(getOverviewFilterOptions, dispatch),
  applyFilter: (filters: FiltersMap) => dispatch(setAppliedFilter(filters)),
  resetFilter: () => dispatch(resetAppliedFilter()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(GenericItemsView as (props: GenericItemsViewProps<CampaignOverview>) => React.ReactElement);
